import { render, staticRenderFns } from "./liveAdd.vue?vue&type=template&id=3370d023"
import script from "./liveAdd.vue?vue&type=script&lang=js"
export * from "./liveAdd.vue?vue&type=script&lang=js"
import style0 from "./liveAdd.vue?vue&type=style&index=0&id=3370d023&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports